import type { CheckboxSelectionCallbackParams, ColDef, GridOptions, IRowNode } from 'ag-grid-community';

import { TypeAddGoodsModalGoods } from '~/types/receive.types';

type GetReceiveAddGoodsModalColumnDefsParams = {
  hasPermissionNFA: boolean;
  /** 이미 등록된 상품코드 목록 (중복 선택 방지용) */
  registeredGoodsCodes?: string[];
};

/**
 * [입고관리 > 입고요청관리] 입고상품추가 모달 테이블
 */
const getReceiveAddGoodsModalColumnDefs = ({
  hasPermissionNFA,
  registeredGoodsCodes = [],
}: GetReceiveAddGoodsModalColumnDefsParams) => {
  const registeredGoodsCodesSet = new Set(registeredGoodsCodes);

  const isGoodsAlreadyRegistered = (goodsCode: string) => registeredGoodsCodesSet.has(goodsCode);

  const gridOptions: GridOptions = {
    isRowSelectable: (params: IRowNode<TypeAddGoodsModalGoods>) => {
      if (!params.data?.goodsCode) return true;
      return !isGoodsAlreadyRegistered(params.data.goodsCode);
    },
    rowClassRules: {
      'ag-row-disabled': (params) => {
        if (!params.data?.goodsCode) return false;
        return isGoodsAlreadyRegistered(params.data.goodsCode);
      },
    },
  };

  const columnDefs: ColDef<TypeAddGoodsModalGoods>[] = [
    {
      headerName: '',
      valueFormatter: () => '',
      headerCheckboxSelection: true,
      checkboxSelection: (params: CheckboxSelectionCallbackParams<TypeAddGoodsModalGoods>) => {
        if (!params.data?.goodsCode) return true;
        return !isGoodsAlreadyRegistered(params.data.goodsCode);
      },
      showDisabledCheckboxes: true,
      width: 44,
    },
    {
      field: 'goodsCode',
      headerName: '상품코드',
      width: 140,
    },
    {
      hide: !hasPermissionNFA,
      field: 'nsid',
      headerName: 'NSID',
      width: 180,
    },
    {
      field: 'alternativeCode',
      headerName: '상품바코드',
      width: 150,
    },
    {
      field: 'goodsName',
      headerName: '상품명',
      minWidth: 240,
      flex: 1,
    },
    {
      field: 'mainCategoryDesc',
      headerName: '대분류',
      width: 140,
    },
    {
      field: 'middleCategoryDesc',
      headerName: '중분류',
      width: 140,
    },
    {
      field: 'thirdCategoryDesc',
      headerName: '소분류',
      width: 140,
    },
    {
      field: 'kurlyKeepTypeDesc',
      headerName: '보관유형',
      width: 100,
    },
    {
      field: 'shelfLifeTypeDesc',
      headerName: '유통/소비기한',
      width: 140,
    },
  ];

  return { gridOptions, columnDefs };
};

export default getReceiveAddGoodsModalColumnDefs;
